import api from './api';
import { Veiculo, ApiResponse } from '../types';

export const veiculoService = {
  listar: async (): Promise<Veiculo[]> => {
    const response = await api.get<Veiculo[]>('/veiculos');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Veiculo> => {
    const response = await api.get<Veiculo>(`/veiculos/${id}`);
    return response.data;
  },

  cadastrar: async (veiculo: Veiculo): Promise<ApiResponse<Veiculo>> => {
    const response = await api.post<ApiResponse<Veiculo>>('/veiculos', veiculo);
    return response.data;
  },

  atualizar: async (id: number, veiculo: Veiculo): Promise<ApiResponse<Veiculo>> => {
    const response = await api.put<ApiResponse<Veiculo>>(`/veiculos/${id}`, veiculo);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/veiculos/${id}`);
    return response.data;
  },

  listarPorStatus: async (status: string): Promise<Veiculo[]> => {
    const response = await api.get<Veiculo[]>(`/veiculos/status/${status}`);
    return response.data;
  },

  listarMeus: async (): Promise<Veiculo[]> => {
    const response = await api.get<Veiculo[]>('/veiculos/meus');
    return response.data;
  },
};
